import React from 'react'
import BackgroundImage from 'gatsby-background-image'
import { graphql, useStaticQuery, Link } from 'gatsby'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

import { Grid } from '@material-ui/core'

const getCategories = graphql`
  query Categories {
    allContentfulCategories {
      nodes {
        id
        categorySlug
        categoryTitle
        categoryImage {
          fluid {
            ...GatsbyContentfulFluid
          }
        }
      }
    }
    contentfulInformation(title: { eq: "Lead" }) {
      content {
        json
      }
    }
  }
`

const Categories = () => {
  const data = useStaticQuery(getCategories)
  return (
    <Grid
      container
      className="bgWhite extraPaddingBottom"
      direction="column"
      alignItems="center"
    >
      <Grid item xs={12} md={10} lg={8}>
        <h3>Our Handmade Products</h3>

        {documentToReactComponents(data.contentfulInformation.content.json)}
      </Grid>
      <Grid
        container
        item
        xs={12}
        md={10}
        lg={8}
        className="itemsContainer"
        justify="space-between"
        alignItems="center"
        spacing={2}
      >
        {data.allContentfulCategories.nodes.map(category => {
          return (
            <Grid item xs={12} md={6} lg={4} key={category.id}>
              <Link
                className="imageText"
                to={`/products/${category.categorySlug}`}
              >
                {category.categoryTitle}
              </Link>
              <BackgroundImage
                fluid={category.categoryImage.fluid}
                alt={category.categoryTitle}
              />
            </Grid>
          )
        })}
      </Grid>
    </Grid>
  )
}

export default Categories
